import classNames from 'clsx';
import React from 'react';

import styles from './NameBar.scss';

export interface NameBarProps {
  tournamentName: string;
  className?: string;
}

const NameBar: React.FC<NameBarProps> = ({ tournamentName, className = '' }) => (
  <div className={classNames(styles.root, className)}>
    <div className={styles.background} />
    <span className={styles.tournamentName} title={tournamentName}>
      {tournamentName}
    </span>
  </div>
);

export default NameBar;
